import { render, staticRenderFns } from "./itemlist.vue?vue&type=template&id=6471bd23&"
import script from "./itemlist.vue?vue&type=script&lang=js&"
export * from "./itemlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports